import React from 'react'

const BellIcon = ({ color = '#999FAC' }) => {
  return (
    <svg
      fill="#808697"
      width="24"
      height="24"
      viewBox="0 0 34 34"
      version="1.1"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>bell-solid</title>
      <path
        className="clr-i-solid clr-i-solid-path-1"
        d="M32.85,28.13l-.34-.3A14.37,14.37,0,0,1,30,24.9a12.63,12.63,0,0,1-1.35-4.81V15.15A10.81,10.81,0,0,0,19.21,4.4V3.11a1.33,1.33,0,1,0-2.67,0V4.42A10.81,10.81,0,0,0,7.21,15.15v4.94A12.63,12.63,0,0,1,5.86,24.9a14.4,14.4,0,0,1-2.47,2.93l-.34.3v2.82H32.85Z"
      ></path>
      <path
        className="clr-i-solid clr-i-solid-path-2"
        d="M15.32,32a2.65,2.65,0,0,0,5.25,0Z"
      ></path>
      <rect x="0" y="0" width="24" height="24" fillOpacity="0" />
    </svg>
  )
}

export default BellIcon
